import { Users, FileText, MessageSquare, Euro, Crown } from "lucide-react";
import { formatMoney } from "../../lib/currency";

function StatBox({ icon, label, value, accent }) {
  const cls = accent === "amber" ? "text-amber-400" : accent === "emerald" ? "text-emerald-400" : "text-slate-100";
  return (
    <div className="tech-card p-4">
      <div className="flex items-center gap-2 text-slate-400 mb-2 text-xs">{icon}<span className="label-tech">{label}</span></div>
      <div className={`font-mono-data text-2xl ${cls}`}>{value}</div>
    </div>
  );
}

export default function AdminStatsTab({ stats, t }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="admin-stats">
      <StatBox icon={<Users size={16}/>} label={t("admin.usersTotal")} value={stats.users_total}/>
      <StatBox icon={<Crown size={16}/>} label={t("admin.premiumUsers")} value={stats.users_premium} accent="amber"/>
      <StatBox icon={<Users size={16}/>} label={t("admin.freeUsers")} value={stats.users_free}/>
      <StatBox icon={<FileText size={16}/>} label={t("admin.totalQuotes")} value={stats.quotes_total}/>
      <StatBox icon={<MessageSquare size={16}/>} label={t("admin.rfqsPublished")} value={stats.rfqs_total}/>
      <StatBox icon={<MessageSquare size={16}/>} label={t("admin.offersReceived")} value={stats.offers_total}/>
      <StatBox icon={<Euro size={16}/>} label={t("admin.revenue")} value={formatMoney(stats.revenue_paid_eur, "EUR")} accent="emerald"/>
    </div>
  );
}
